<template>
  <ais-refinement-list
    operator="and"
    :attribute="filter.id"
    :transformItems="transformItems"
    :limit="999"
  >
    <template v-slot="{ items, refine }">
      <div class="finish-filter">
        <div class="filter-values flex items-center">
          <div
            v-for="item in items"
            :key="item.value"
            class="filter-value"
            :class="{
              [`${getFinishClassName(item.value)}`]: true,
              active: item.isRefined,
            }"
            :title="item.label"
            @click="refine(item.value)"
          >
            <SloIcon v-if="item.isRefined" name="XMark" />
          </div>
        </div>
      </div>
    </template>
  </ais-refinement-list>
</template>

<script>
import {transformItems} from '../../product-configurator/filters-config';
import {getFinishClassName} from '../../product-configurator/finish-translations';
import SloIcon from '../../../lib/components/SloIcon.vue';

export default {
  components: {
    SloIcon
  },
  props: {
    filter: {type: Object, required: true}
  },
  methods: {
    transformItems(items) {
      return transformItems(this.filter, items);
    },
    getFinishClassName
  }
};
</script>

<style scoped lang="scss">
@import '../../../scss/system';

$finish-chrome: #f2f4f6;
$finish-nickel: #e2ded4;
$finish-brass: #efdaa3;
$finish-stainless: #dadcde;
$finish-graphite: #5f5f5f;
$finish-black: #323232;
$finish-white: #eeeeee;

.filter-values {
  min-height: 40px;
}

.filter-value {
  position: relative;
  box-sizing: content-box;
  border: 8px solid transparent;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-clip: padding-box !important;
  cursor: pointer;
  transition: transform 200ms cubic-bezier(0.23, 1, 0.32, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  color: $color-gray-700;

  &:hover,
  &:focus {
    transform: scale(1.05);
    box-shadow: 0 0 0 1px $color-gray-300;
  }

  &:active,
  &.active {
    transform: scale(1);
    box-shadow: 0 0 0 1px $color-gray-700;
  }

  &:first-child {
    margin-left: -8px;
  }

  &::after {
    content: '';
    position: absolute;
    top: 1px;
    right: 1px;
    bottom: 1px;
    left: 1px;
    border-radius: 50%;
    pointer-events: none;
  }
}

.polished-chrome {
  background: $finish-chrome;

  &::after {
    border: 1px solid $color-gray-300;
  }
}

.brushed-nickel {
  background: $finish-nickel;
}

.brushed-stainless {
  background: $finish-stainless;
}

.polished-brass {
  background: $finish-brass;
}

.graphite {
  background: $finish-graphite;
  color: $color-white;
}

.matte-black {
  background: $finish-black;
  color: $color-white;
}

.stainless-steel {
  background: $finish-stainless;
  color: $color-white;
}

.black {
  background: $finish-black;
  color: $color-white;
}

.matte-white,
.polished-white {
  background: $finish-white;

  &::after {
    border: 1px solid $color-gray-300;
  }
}
</style>
